var $146218e7e6749652$exports = {};
$146218e7e6749652$exports = {
    "collapse": `Pienenn\xe4`,
    "expand": `Laajenna`
};


export {$146218e7e6749652$exports as default};
//# sourceMappingURL=fi-FI.module.js.map
